var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 622 670",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.1;}.cls-1,.cls-2{fill:#fff;}.cls-3{fill:#007698;}.cls-2{opacity:.2;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 0,
    width: 622,
    height: 670
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m280.19,793.15l-29.39-41.15c41.14-73.45,58.75-149.83,79.33-226.21,26.44-126.33,49.95-355.51-114.57-355.51-152.76,0-243.85,199.79-270.29,331.99-41.14,188.03,70.5,323.19,249.73,323.19,58.75,0,161.59-8.81,220.34-29.39l-26.44,52.9c-79.33,26.43-193.91,38.19-273.24,38.19-229.17,0-361.38-138.09-311.43-381.94C-151.69,296.64,6.95,120.34,218.49,120.34s290.87,152.76,249.73,361.38c-17.63,111.65-88.14,237.97-188.03,311.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1178.81,1804.27l-98.46-137.83c137.84-246.09,196.82-501.98,265.78-757.87,88.57-423.21,167.33-1190.97-383.82-1190.97-511.78,0-816.94,669.31-905.5,1112.21-137.84,629.92,236.2,1082.72,836.63,1082.72,196.82,0,541.36-29.49,738.17-98.46l-88.56,177.22c-265.78,88.56-649.61,127.94-915.39,127.94-767.76,0-1210.66-462.6-1043.33-1279.53C-268.05,140.91,263.42-449.72,972.11-449.72S1946.57,62.05,1808.73,760.93c-59.07,374.04-295.26,797.25-629.92,1043.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginWindow);
export default __webpack_public_path__ + "static/media/Login-window.34be94467a2f2d00ecd1dbd9653c0a88.svg";
export { ForwardRef as ReactComponent };